/*
  TROVI Marketplace · "Recently viewed" (Agente D).
  Guarda hasta 12 handles en localStorage (clave tv_recent) y los pinta
  con /products/{handle}.js. Sin dependencias externas.
*/
(function () {
  'use strict';

  var KEY = 'tv_recent';
  var MAX = 12;

  // El historial guarda identidad, nunca el idioma de una visita anterior.
  function normalizeHandle(value) {
    if (typeof value !== 'string') return '';
    var path = value.match(/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?products\/([^/?#]+)\/?(?:[?#].*)?$/i);
    if (path) {
      try { value = decodeURIComponent(path[1]); } catch (e) { return ''; }
    }
    return /^[^/\\?#:\s%]+$/.test(value) ? value : '';
  }

  function readList() {
    try {
      var raw = window.localStorage.getItem(KEY);
      if (!raw) return [];
      var parsed = JSON.parse(raw);
      return Array.isArray(parsed) ? parsed.map(normalizeHandle).filter(function (h, i, list) {
        return h && list.indexOf(h) === i;
      }) : [];
    } catch (e) {
      return [];
    }
  }

  function writeList(list) {
    try {
      window.localStorage.setItem(KEY, JSON.stringify(list.slice(0, MAX)));
    } catch (e) {
      /* modo privado o cuota llena: se ignora */
    }
  }

  function remember(handle) {
    if (!handle) return;
    var list = readList().filter(function (h) { return h !== handle; });
    list.unshift(handle);
    writeList(list);
  }

  function formatMoney(cents, format, currency) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function' && format) {
      try {
        return window.Shopify.formatMoney(cents, format);
      } catch (e) {
        /* cae al Intl */
      }
    }
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency',
        currency: currency || 'USD',
      }).format(cents / 100);
    } catch (e) {
      return '$' + (cents / 100).toFixed(2);
    }
  }

  function imageUrl(src, width) {
    if (!src) return '';
    return src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
  }

  function buildCard(product, root, format, currency) {
    var li = document.createElement('li');

    var a = document.createElement('a');
    a.className = 'tv-mini-card';
    // Shopify puede devolver product.url ya localizado; no se concatena dos veces.
    a.href = root + '/products/' + encodeURIComponent(product.handle);

    var media = document.createElement('div');
    media.className = 'tv-mini-card__media';
    if (product.featured_image) {
      var img = document.createElement('img');
      img.src = imageUrl(product.featured_image, 300);
      img.alt = product.title || '';
      img.loading = 'lazy';
      img.width = 150;
      img.height = 150;
      media.appendChild(img);
    }
    a.appendChild(media);

    var title = document.createElement('p');
    title.className = 'tv-mini-card__title';
    title.textContent = product.title || '';
    a.appendChild(title);

    var price = document.createElement('p');
    price.className = 'tv-mini-card__price';
    price.textContent = formatMoney(product.price, format, currency);
    a.appendChild(price);

    li.appendChild(a);
    return li;
  }

  function render(container) {
    var current = container.dataset.currentHandle || '';
    var root = (container.dataset.root || '/').replace(/\/$/, '');
    var format = container.dataset.moneyFormat || '';
    var currency = container.dataset.currency || 'USD';
    var list = container.querySelector('[data-tv-recent-list]');
    if (!list) return;

    var handles = readList()
      .filter(function (h) { return h !== current; })
      .slice(0, MAX);

    if (!handles.length) return;

    var requests = handles.map(function (handle) {
      return fetch(root + '/products/' + encodeURIComponent(handle) + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    });

    Promise.all(requests).then(function (products) {
      var found = products.filter(Boolean);
      if (!found.length) return;
      var fragment = document.createDocumentFragment();
      found.forEach(function (product) {
        fragment.appendChild(buildCard(product, root, format, currency));
      });
      list.appendChild(fragment);
      container.hidden = false;
    });
  }

  function init() {
    document.querySelectorAll('[data-tv-recently-viewed]').forEach(function (container) {
      if (container.dataset.tvInit === 'true') return;
      container.dataset.tvInit = 'true';
      render(container);
      // se recuerda DESPUÉS de pintar para no mostrarse a sí mismo
      remember(container.dataset.currentHandle || '');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
